import { defineDrupalBehavior } from '@lib/defineDrupalBehavior';
import { desktopMediaQuery } from '@lib/media-query';

defineDrupalBehavior('ProductDetailsPage', '[data-pdp]', (pdp) => {
    const desktopMQ = desktopMediaQuery();
    const gallery = pdp.querySelector<HTMLDivElement>('[data-pdp-gallery]');
    const headline = pdp.querySelector<HTMLDivElement>('[data-pdp-headline]');

    function positionGalleryOnDesktop() {
        if (!gallery || !headline) return;
        if (desktopMQ.matches) {
            gallery.style.top = headline.offsetTop + headline.offsetHeight + 'px';
        } else {
            gallery!.style.removeProperty('top');
        }
    }

    positionGalleryOnDesktop();
    desktopMQ.addListener(positionGalleryOnDesktop);
});
